import { render } from "./App.vue?vue&type=template&id=441b4e72"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=441b4e72&lang=less"
script.render = render

export default script